import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys } from "vue"

import { ref, reactive, onMounted } from 'vue';
import type { FormInstance } from 'element-plus';
import { useRoute } from 'vue-router';
import { useUserStore } from '@/store';
import AutotrimInput from '@/components/autotrim-input/AutotrimInput.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'projectSearch',
  emits: ['on-search', 'on-reset'],
  setup(__props, { emit: __emit }) {

const userStore = useUserStore();
const route = useRoute();
const emit = __emit;

const formRef = ref();
const form = reactive({
  projectName: '',
  sid: route.query?.sid ? parseInt(route.query.sid as string, 10) : null
});

const sysList = ref<any>([]);
onMounted(() => {
  userStore.systemList().then((res) => {
    sysList.value = res;
  });
});

const onReset = (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  formEl.resetFields();
  emit('on-reset', { ...form });
};

const onSubmit = () => {
  emit('on-search', { ...form });
};

return (_ctx: any,_cache: any) => {
  const _component_e_option = _resolveComponent("e-option")!
  const _component_e_select = _resolveComponent("e-select")!
  const _component_e_form_item = _resolveComponent("e-form-item")!
  const _component_e_form = _resolveComponent("e-form")!
  const _component_e_filter = _resolveComponent("e-filter")!

  return (_openBlock(), _createBlock(_component_e_filter, {
    "show-reset": "",
    "enter-search": "",
    onReset: _cache[3] || (_cache[3] = ($event: any) => (onReset(formRef.value))),
    onSearch: onSubmit
  }, {
    default: _withCtx(() => [
      _createVNode(_component_e_form, {
        ref_key: "formRef",
        ref: formRef,
        inline: true,
        "label-position": "right",
        model: form,
        "label-width": "80px",
        "show-ellipsis": false
      }, {
        default: _withCtx(() => [
          _createVNode(_component_e_form_item, {
            label: "所属系统",
            prop: "sid"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_e_select, {
                modelValue: form.sid,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.sid) = $event)),
                placeholder: "请选择所属系统",
                filterable: "",
                clearable: "",
                onClear: _cache[1] || (_cache[1] = 
            () => {
              form.sid = null;
            }
          )
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sysList.value, (item) => {
                    return (_openBlock(), _createBlock(_component_e_option, {
                      key: item.sid,
                      value: item.sid,
                      label: item.sysName
                    }, null, 8, ["value", "label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_e_form_item, {
            label: "项目名称",
            prop: "projectName"
          }, {
            default: _withCtx(() => [
              _createVNode(AutotrimInput, {
                modelValue: form.projectName,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.projectName) = $event)),
                placeholder: "请输入项目名称",
                clearable: "",
                maxlength: 50,
                onKeyup: _withKeys(onSubmit, ["enter"])
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }))
}
}

})